import { useState } from "react";
import { useMutation } from "react-query";
import { postData } from "../../../api/api";
import { useApplicationDetails } from "../../../hooks/useApplicationDetails";
import { getQueryConfiguration } from "../../../utils";
import { RegistrationDialogPresenter } from "./RegistrationDialogPresenter";

const RegistrationDialog = (props) => {
    const [completed, setCompleted] = useState(false);
    const [message, setMessage] = useState();

    const { customization } = useApplicationDetails();

    const mutation = useMutation((resource) => postData(`/accounts/register`, resource), {
        onMutate: () => {
            setMessage();
        },
        onSuccess: () => {
            props.onClose?.();

            setCompleted(true);

            setMessage("Account validation email has been sent.");
        },
    });

    const { applicationId } = getQueryConfiguration();

    const handleSave = (details) => {
        mutation.mutate({
            ...details,
            applicationId,
        });
    };

    return (
        <RegistrationDialogPresenter
            {...props}
            title="Account registration"
            applicationId={applicationId}
            requirement={customization?.requirement}
            saving={mutation.isLoading}
            completed={completed}
            message={message}
            error={mutation.error?.response.data.message}
            onSave={handleSave}
            onCancel={props.onClose}
        />
    );
};

export default RegistrationDialog;
